<template>
  <b-row align-h="end" class="mb-4">
    <b-col cols="8" v-if="totalItems">
      <div>{{ totalItems }} {{ itemsName }}</div>
    </b-col>
    <b-col cols="4">
      <b-form inline class="float-right">
        <label for="items-on-page-select" class="label-select">Items on page</label>
        <b-form-select size="sm"
                       id="items-on-page-select"
                       class="ml-1"
                       v-model="selected"
                       :options="options"
                       @change="onSelectChange"
        />
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
  import { itemsOnPageDefault } from '@/services/mixins';

  export default {
    props: {
      itemsOnPageDefault: { type: Number, required: false},
      totalItems: { type: Number, required: false },
      itemsName: { type: String, required: false },
      options: { type: Array, required: true },
      onSelectChange: { type: Function, required: true },
    },
    data() {
      return {
        selected: this.itemsOnPageDefault || itemsOnPageDefault,
      }
    }
  };
</script>

<style scoped>
  .label-select {
    font-size: .875rem;
  }

  #items-on-page-select {
    width: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/ItemsOnPageSelect.vue